export default __webpack_public_path__ + "static/media/signature-survey-logo.abefb473.png";